import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useRef, useEffect } from 'react';
import { FloatingInputWrapper } from '@chegg-ui/input-wrapper';
import { getThemeConfig } from '@chegg-ui/input';
import { ValidationManager, SpecType, SubType, InfoText, sendRioEvent, Namespace, StatusTypes, Component, UserAddressCommandNames, removeExcessiveSpace, ElementType, fireStatusUpdate } from '@chegg/commerce-utils';
import { LoadingIcon, useComponentTheme } from '@chegg-ui/theme';
import { ZipcodeFieldWrapper, DropdownOptionsWrapper, DropdownOptions, ShowSelection, CitySuggestionWrapper, CityError, ProgressIndicator, ZipcodeInput, CitySuggestionHeading } from './styled';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { ERRORS, InlineError } from '../../constants/Errors';
import { selectItem, displayCityAddress, getZipCodeValidationText, getCityValidationText, getZipInputMode } from './helpers';
import { strings } from '../../constants/strings';
import { fireCallbackLoggingEvent } from '../../utils/CallbackUtil';
import { useDispatch, useSelector } from 'react-redux';
import { updatedZipcode, selectedCity as selectedCityAction, setCityFlags } from '../../redux/UserAddressState/UserAddressState.slice';
import { getCities } from '../../redux/UserAddressState/UserAddressState.actions';
var types = ValidationManager.types,
  validateField = ValidationManager.validateField,
  fieldValidationMap = ValidationManager.fieldValidationMap;
var CCFIELDS = types.CCFIELDS;
var ZipcodeField = function ZipcodeField() {
  var _useSelector = useSelector(function (state) {
      return {
        userAddressState: state.userAddress,
        rioNamespace: state.config.rioNamespace,
        zipField: state.config.zipField,
        cityField: state.config.cityField,
        isUpi: state.config.isUpi,
        inputDisabled: state.config.inputDisabled
      };
    }),
    userAddressState = _useSelector.userAddressState,
    rioNamespace = _useSelector.rioNamespace,
    zipField = _useSelector.zipField,
    cityField = _useSelector.cityField,
    isUpi = _useSelector.isUpi,
    inputDisabled = _useSelector.inputDisabled;
  var _userAddressState$zip = userAddressState.zip,
    zip = _userAddressState$zip === void 0 ? {
      isMandatory: false,
      focused: false,
      value: '',
      invalid: undefined,
      error: undefined
    } : _userAddressState$zip,
    selectedCity = userAddressState.selectedCity,
    cityFlags = userAddressState.cityFlags,
    progressFlags = userAddressState.progressFlags,
    country = userAddressState.country,
    addressSuggestion = userAddressState.addressSuggestion;
  var isMandatory = zip.isMandatory;
  var cityStates = addressSuggestion.city_states,
    matches = addressSuggestion.matches,
    success = addressSuggestion.success;
  var showAddress = cityFlags.showAddress,
    showSuggestions = cityFlags.showSuggestions,
    error = cityFlags.error;
  var showFetchProgress = progressFlags.showFetchProgress;
  var cityListRef = useRef(null);
  var zipCodeRef = useRef(null);
  var dispatch = useDispatch();
  var inputComponentTheme = useComponentTheme({
    name: 'Input',
    theme: getThemeConfig()
  });
  useEffect(function () {
    if (success) {
      if (matches && matches > 1) {
        !showAddress && dispatch(setCityFlags({
          showSuggestions: true
        }));
      } else {
        dispatch(selectedCityAction(cityStates && cityStates[0] ? _objectSpread({}, cityStates[0]) : {}));
        dispatch(setCityFlags({
          showAddress: true,
          showSuggestions: false
        }));
      }
    } else {
      // empty city object if previously used another zipcode with correct city
      dispatch(selectedCityAction({}));
      dispatch(setCityFlags({
        showAddress: false,
        showSuggestions: false
      }));
    }
  }, [cityStates]);
  var keyPressSelectItem = function keyPressSelectItem(event, item) {
    if (event.key === 'Enter') {
      selectItem(item, dispatch);
    }
  };
  var onFieldChange = function onFieldChange(event, focused, rioNamespace) {
    var _event$currentTarget = event.currentTarget,
      fieldName = _event$currentTarget.name,
      fieldValue = _event$currentTarget.value;
    var requiredError = '';
    // if zip is mandatory, then we should validate the field and see what the error is
    if (isMandatory) {
      var fieldValidations = isUpi ? fieldValidationMap[CCFIELDS.BILLING_ZIP_UPI] : fieldValidationMap[fieldName];
      requiredError = validateField({
        fieldName: fieldName,
        value: fieldValue,
        validations: fieldValidations,
        trim: undefined,
        length: isUpi ? 6 : undefined
      }).error || '';
    }
    // show zipcode is required inline error onBlur
    if (requiredError && !focused) {
      sendRioEvent({
        info: InfoText.ZIP_ERROR,
        message_detail: InlineError.REQUIRED,
        specType: SpecType.NOTIFICATION,
        subType: SubType.ERROR,
        callback: function callback(logObj) {
          return fireCallbackLoggingEvent(logObj);
        },
        namespace: rioNamespace
      });
      fireStatusUpdate([{
        status: StatusTypes.ERROR,
        command: UserAddressCommandNames.VERIFY_ADDRESS,
        payload: {
          component: Component.ZIPCODE,
          errors: [_objectSpread(_objectSpread({}, ERRORS.INLINE_ERRORS), {}, {
            message: requiredError
          })]
        }
      }], Namespace.USER_ADDRESS);
    }

    // focus zipcode field even city dropdown is open, show error onBlur zipcode
    if (showSuggestions && !focused) {
      setTimeout(function () {
        dispatch(setCityFlags({
          error: true
        }));
        fireStatusUpdate([{
          status: StatusTypes.ERROR,
          command: UserAddressCommandNames.VERIFY_ADDRESS,
          payload: {
            component: Component.CITY_SELECTED,
            errors: [_objectSpread(_objectSpread({}, ERRORS.INLINE_ERRORS), {}, {
              message: requiredError
            })]
          }
        }], Namespace.USER_ADDRESS);
        cityListRef.current.focus();
      }, 200);
    } else {
      dispatch(setCityFlags({
        error: false
      })); // set this false as this function is also gets fired onChange zipcode
    }

    // keep field value in sync
    if (focused) {
      dispatch(updatedZipcode({
        value: fieldValue,
        error: requiredError,
        invalid: '',
        focused: focused
      }));
    } else {
      dispatch(updatedZipcode({
        value: removeExcessiveSpace(value),
        error: requiredError,
        focused: focused
      }));
    }

    // setTimeout if user types zipcode very quickly
    // timeout is set less because otherwise it makes multiple calls to api
    // until we figure out a proper execution of not dispatching action multiple times
    setTimeout(function () {
      // condition if tab on zip pasting code instanly, focused turn false because setTimeout
      // until it executes getCities, so it doesn't make addressValidation call
      focused ? dispatch(getCities({
        countryFocused: true
      })) : dispatch(getCities({}));
    }, 100);
  };
  function onFieldFocus(event, focused, rioNamespace) {
    var value = event.currentTarget.value;
    var error = '';
    var invalid = '';

    // user enters zip code field
    sendRioEvent({
      info: InfoText.ZIPCODE_INPUT,
      specType: SpecType.INTERACTION,
      subType: SubType.TEXT,
      elementType: ElementType.TEXT,
      callback: function callback(logObj) {
        return fireCallbackLoggingEvent(logObj);
      },
      namespace: rioNamespace
    });

    // keep field value in sync
    dispatch(updatedZipcode({
      value: value,
      error: error,
      invalid: invalid,
      focused: focused
    }));
  }
  var focused = zip.focused,
    value = zip.value;
  var citySuggestions = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressIndicator, {
    isDisplay: showFetchProgress,
    "aria-label": 'City and State are being fetched.',
    role: 'alert'
  }, /*#__PURE__*/React.createElement(LoadingIcon, {
    size: 'medium'
  })), /*#__PURE__*/React.createElement(CitySuggestionWrapper, {
    isOpen: showSuggestions,
    role: 'alert',
    "aria-label": 'Press tab to go through the list of suggested cities.',
    error: error
  }, /*#__PURE__*/React.createElement(DropdownOptionsWrapper, {
    "data-test": DataTestAttributes.CITY_SUGGESTIONS,
    "aria-expanded": showSuggestions,
    ref: cityListRef,
    error: error
  }, /*#__PURE__*/React.createElement(CitySuggestionHeading, null, (cityField === null || cityField === void 0 ? void 0 : cityField.labelText) || strings['APP.FORM.LABEL.CITY']), cityStates && cityStates.map(function (item) {
    return /*#__PURE__*/React.createElement(DropdownOptions, {
      key: item.city,
      id: item.city,
      onMouseDown: function onMouseDown() {
        return selectItem(item, dispatch);
      }
    }, /*#__PURE__*/React.createElement("a", {
      role: 'button',
      tabIndex: 0,
      onKeyDown: function onKeyDown(event) {
        return keyPressSelectItem(event, item);
      }
    }, displayCityAddress(item)));
  })), error && /*#__PURE__*/React.createElement(CityError, {
    "data-test": DataTestAttributes.CITY_ERROR,
    role: 'alert',
    "aria-live": 'polite'
  }, getCityValidationText(cityField))), /*#__PURE__*/React.createElement(ShowSelection, {
    isShow: showAddress,
    role: 'alert',
    "data-test": DataTestAttributes.CITY_SELECTED,
    "aria-live": 'assertive'
  }, displayCityAddress(selectedCity)));
  return /*#__PURE__*/React.createElement(ZipcodeFieldWrapper, {
    "data-disabled": inputDisabled
  }, /*#__PURE__*/React.createElement(FloatingInputWrapper, {
    inputId: CCFIELDS.BILLING_ZIP,
    labelText: (zipField === null || zipField === void 0 ? void 0 : zipField.labelText) || strings['APP.FORM.LABEL.ZIPCODE'],
    errorText: getZipCodeValidationText(zip, zipField),
    isFloating: focused || Boolean(value)
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ZipcodeInput, {
    inputMode: getZipInputMode(country.countryCode),
    errorText: getZipCodeValidationText(zip, zipField),
    "data-test": DataTestAttributes.ZIPCODE,
    name: CCFIELDS.BILLING_ZIP,
    id: CCFIELDS.BILLING_ZIP,
    ref: zipCodeRef,
    onChange: function onChange(e) {
      return onFieldChange(e, true, rioNamespace);
    },
    onBlur: function onBlur(e) {
      return onFieldChange(e, false, rioNamespace);
    },
    onFocus: function onFocus(e) {
      return onFieldFocus(e, true, rioNamespace);
    },
    autoComplete: 'postal-code',
    value: value,
    "aria-required": 'true',
    "aria-invalid": !!zip.error,
    "aria-live": 'polite',
    customTheme: inputComponentTheme,
    disabled: inputDisabled,
    "data-recurly": "postal_code"
  }), citySuggestions)));
};
export default ZipcodeField;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/internal/ZipcodeField/ZipcodeField.js
// module id = 4515
// module chunks = 11